import { FiSettings, RiBuildingLine } from 'react-icons/all';
import React from 'react';

export const GNB_ADMIN_MENU = [
  { link: '/admin/list', name: '업체 관리', icon: <RiBuildingLine /> },
  { link: '/admin/setting', name: '정보 수정', icon: <FiSettings /> },
];